import qs from 'qs'
import slugify from 'slugify'
import globals from '../../utils/globals'

const urlGenerator = (type: string, title: string, id: string, category?: string | null, postId?: string) => {
  const typePath = `/${type}`
  const categoryPath = category ? `/${category}` : ''
  const titlePath = `/${slugify(title)}`
  const idPath = `-${id}`
  const postIdPath = postId ? `?postid=${postId}#post${postId}` : ''
  return (typePath + categoryPath + titlePath + idPath + postIdPath).toLowerCase()
}

export const groupOverviewUrl = (groupId: number, groupTitle?: string) => {
  const host = globals('communityUrl')
  if (groupTitle) {
    return `${host}/groups/${groupTitle.toLowerCase().split(' ').join('-')}-${groupId}`
  }
  return `${host}/groups/${groupId}`
}

export const generateNewUrl = (newPage: number) => {
  const regex = /\/index\d+\.html/
  const splittedUrl = window.location.pathname.replace(regex, '')
  const newPagination = newPage === 1 ? '' : `/index${newPage}.html`
  const searchQuery = window.location.search
  const queryParameters = qs.parse(searchQuery, { ignoreQueryPrefix: true })
  delete queryParameters?.postid
  return `${window.location.origin}${splittedUrl}${newPagination}${qs.stringify(queryParameters) as string}`
}

export default urlGenerator
